export default "__VITE_ASSET__DP7hGJkq__"